module.exports = __webpack_public_path__ + "fonts/HalisR-S-Regular.4b542cca.otf";